import { EducationLevel } from "src/__generated__/graphql";

export const tertiaryQualifications = [
	EducationLevel.Ond,
	EducationLevel.Hnd,
	EducationLevel.Bachelors,
	EducationLevel.Masters,
	EducationLevel.Doctorate,
];
